var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import * as Loader from "./scripts/ts/ImageViewerLoader";
window.MI = { CSG: { IV: __assign(__assign({}, (_b = (_a = window.MI) === null || _a === void 0 ? void 0 : _a.CSG) === null || _b === void 0 ? void 0 : _b.IV), Loader) } };
